import { removeInvalidOptions } from '../../field-viewer/shared-normalizers';
export const quizImageChoiceViewer = {
    normalizeLoadedValue: removeInvalidOptions
};

//# sourceMappingURL=definition-viewer.js.map